import { api, getTenant, getUserName } from '../../../hooks';

export const getCurrentUserMentors = (callback) => {

  try{
    api.iblaxdApiCallWrapper(
      (args) => api.iblaxdaimentorapi.aiMentorOrgsUsersList(...args),
      getTenant(),
      getUserName(), {featured:true, visibility:"viewable_by_tenant_students"},
    )((err, data, response) => callback(data))
  }catch(error){
    callback({})
  }

  /*const userData = JSON.parse(localStorage.getItem('userData'));
  const username = userData?.user_nicename;
  const tenant = getTenant()
  const url =
    process.env.REACT_APP_IBL_AXD_URL +
    `/api/ai/mentor/orgs/${tenant}/users/${username}/`;
  const token = localStorage.getItem('token');
  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: 'Token ' + token,
    },
  });*/
};

export const getPageSlug = () => {
  let slug = window.location.pathname;
  slug = slug.replace('/', '');
  slug = slug.replace('.html', '');
  if (slug[slug.length - 1] === '/') {
    slug = slug.substring(0, slug.length - 1);
  }
  return slug;
};

export const isJSON = (text) => {
  if (typeof text !== 'string') {
    return false;
  }
  try {
    JSON.parse(text);
    return true;
  } catch (error) {
    return false;
  }
};

export const pushTokenToMentor = (whiteThemed=true) => {
  const iframedSite: HTMLIFrameElement =
    document.querySelector('#iframed-mentor');
  //const slug = getPageSlug();
  const data = {
    ...localStorage,
    //DARK MODE ACTIVATION ON ANALYTICS
    ...(!whiteThemed ? {
      theme: 'dark'
    } : {})
  };
  const message = JSON.stringify(data);
  iframedSite.contentWindow?.postMessage(message, '*');
  //DARK MODE ACTIVATION ON ANALYTICS
  /*if (!whiteThemed) {
    const iframeInjectData = {
      theme: 'dark',
    };
    const iframeInJectMessage = JSON.stringify(iframeInjectData);
    iframedSite.contentWindow?.postMessage(iframeInJectMessage, '*');
  }*/
};
